<router-outlet></router-outlet>

<!-- Global Toast Container — centered at top -->
<div class="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-3 pointer-events-none">
    <alert class="pointer-events-auto" [appearance]="'soft'" [dismissible]="true" [dismissed]="true"
           [name]="'successAlertBox'" [type]="'success'">
    </alert>

    <alert class="pointer-events-auto" [appearance]="'soft'" [dismissible]="true" [dismissed]="true"
           [name]="'errorAlertBox'" [type]="'error'">
    </alert>

    <alert class="pointer-events-auto" [appearance]="'soft'" [dismissible]="true" [dismissed]="true"
           [name]="'warningAlertBox'" [type]="'warning'">
    </alert>

    <alert class="pointer-events-auto" [appearance]="'soft'" [dismissible]="true" [dismissed]="true"
           [name]="'infoAlertBox'" [type]="'info'">
    </alert>
</div>